module.exports = __webpack_public_path__ + "img/06.8dd737bf.png";